module.exports = __webpack_public_path__ + "img/icon-white-9.3fd57f9f.svg";